export const BASE = process.env.REACT_APP_BASE_URL;
export const REDIRECT = process.env.REACT_APP_REDIRECT_URL;
export const WEB_APP = process.env.REACT_APP_WEB_APP_URL;

export const PAGES_ENDPOINTS = {
  MAIN: '/',
  LOGIN: '/login',
  SUBJECTS: '/subjects',
  TEACHERS: '/teachers',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  ADMIN: '/admin',
};

export const AUTH_ENDPOINTS = {
  TOKEN: '/token',
  TOKEN_REFRESH: '/token/refresh',
  USER: '/me',
  KENNISNET: '/oauth2/authorize/kennisnet',
};

export const PROFILE_ENDPOINTS = {
  EMPLOYEE: '/api/employee/profile',
  STUDENT: '/api/employee/student/{id}/profile',
  SETTINGS: '/organization/settings',
};

export const DATA_ENDPOINTS = {
  CLASSES_BREAKDOWN: '/organization/classes/breakdown',
  SUBJECTS: '/api/subjects/studyspace',
  SETTINGS: '/settings',
  TABLE: {
    STUDENTS: '/organization/students',
    TEACHERS: '/organization/teachers',
    SUBJECTS: '/api/subjects/table/studyspace',
  },
  STUDENT_AUTOCOMPLETE: '/api/student/autocomplete',
  STUDENT_USER_ID: '/api/student/{id}/user-id',
};

export const SUBMIT_ENDPOINTS = {
  SETTINGS: {
    UPDATE: '/organization/settings',
  },
  SUBJECTS: {
    HIDE: '/api/subjects/{id}/hide',
    UNHIDE: '/api/subjects/unhide',
    EDIT: '/api/subjects/{id}/methods',
    CREATE: '/api/subjects/studyspace',
    UPDATE: '/api/subjects/{id}/studyspace',
    DELETE: '/api/subjects/{id}/studyspace',
  },
  TEACHERS: {
    UPDATE: '/api/employee/{id}',
    ROLE: '/organization/teachers/{id}/role',
  },
  STUDENTS: {
    UPDATE: '/api/student/{id}',
    DELETE: '/api/student/{id}',
  },
};
